import React from 'react';
import { useTranslation } from 'react-i18next';

export type FitStep = 1 | 2 | 3;

export interface FitStepProgressProps {
  currentStep: FitStep;
}

export const FitStepProgress: React.FC<FitStepProgressProps> = ({ currentStep }) => {
  const { i18n } = useTranslation();
  const isNl = !!(i18n?.language && i18n.language.startsWith('nl'));
  const steps = [
    { id: 1 as FitStep, nl: 'Items', en: 'Items' },
    { id: 2 as FitStep, nl: 'Pasfoto', en: 'Photo' },
    { id: 3 as FitStep, nl: 'Stijl', en: 'Style' },
  ];

  const label = (nl: string, en: string) => (isNl ? nl : en);

  const circleCls = (id: FitStep) => {
    if (id === currentStep) return 'bg-orange-500 text-white border-orange-500';
    if (id < currentStep) return 'bg-white text-orange-500 border-orange-500';
    return 'bg-white text-gray-400 border-gray-300';
  };

  const lineCls = (leftId: FitStep) => {
    return leftId < currentStep ? 'bg-orange-500' : 'bg-gray-300';
  };

  return (
    <div className="w-full mb-4">
      <div className="flex items-center justify-center gap-3 md:gap-6">
        <div className={`w-8 h-8 rounded-full border flex items-center justify-center text-sm font-semibold ${circleCls(1)}`}>1</div>
        <div className={`h-0.5 w-12 md:w-24 ${lineCls(1)}`}></div>
        <div className={`w-8 h-8 rounded-full border flex items-center justify-center text-sm font-semibold ${circleCls(2)}`}>2</div>
        <div className={`h-0.5 w-12 md:w-24 ${lineCls(2)}`}></div>
        <div className={`w-8 h-8 rounded-full border flex items-center justify-center text-sm font-semibold ${circleCls(3)}`}>3</div>
      </div>
      <div className="mt-2 max-w-sm mx-auto grid grid-cols-3 gap-4">
        <div className="text-center text-sm font-medium text-slate-800">{label(steps[0].nl, steps[0].en)}</div>
        <div className="text-center text-sm font-medium text-slate-800">{label(steps[1].nl, steps[1].en)}</div>
        <div className="text-center text-sm font-medium text-slate-800">{label(steps[2].nl, steps[2].en)}</div>
      </div>
      <div className="mt-3 text-center text-sm text-slate-600">
        {label('Doorloop de drie stappen om jouw FiT-sessie te voltooien.', 'Follow the three steps to complete your FiT session.')}
      </div>
    </div>
  );
}

export default FitStepProgress;
